<template>
    <button
        class="btn is-danger ml-lg"
        :class="{ 'is-loading': loading }"
        @click="storeAnonymizationRequest"
    >
        Begär anonymisering
    </button>
</template>
<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            storeAnonymizationRequest() {
                this.loading = true;
                axios.post(route('api.gdpr.anonymization-requests.store'),  { 'projectId': this.project.id })
                    .then(() => {
                        this.$emit('anonymized');
                        flash_success('En begäran om anonymisering skapad!');
                    }).catch(() => {
                        flash_error('Åtgärden misslyckades.');
                    }).then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
